import pmCqiService from '@/services/pmCqiService';

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null,
    period: 'week',
    data: null,
  },

  getters: {
    loading: (state) => state.loading,
    error: (state) => state.error,
    period: (state) => state.period,
    data: (state) => state.data,
    current: (state) => state.data?.current || null,
    history: (state) => state.data?.history || [],
    thresholds: (state) => state.data?.thresholds || { greenMin: 70, yellowMin: 50 },
    inactiveUsersExcluded: (state) => state.data?.inactiveUsersExcluded ?? 0,
    chartBars: (state, getters) => getters.history.map((entry) => ({
      label: entry.label,
      cqi: entry.cqi,
      n: entry.n,
      periodKey: entry.periodKey,
    })),
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PERIOD(state, period) {
      state.period = period || 'week';
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    RESET(state) {
      state.loading = false;
      state.error = null;
      state.period = 'week';
      state.data = null;
    },
  },

  actions: {
    async fetchCqi({ commit, state, rootGetters }, overrides = {}) {
      const projectId = rootGetters['pmProject/selectedProjectId'];
      if (!projectId) {
        commit('SET_DATA', null);
        return null;
      }

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const period = overrides.period || state.period || 'week';
        const data = await pmCqiService.getProjectCqi(projectId, {
          period,
          weeks: overrides.weeks ?? 8,
          months: overrides.months ?? 4,
        });
        commit('SET_DATA', data);
        return data;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load CQI');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async setPeriod({ commit, dispatch }, period) {
      commit('SET_PERIOD', period);
      return dispatch('fetchCqi');
    },
  },
};
